const APPCONFIG = {
  WEATHER_API_KEY: "4fd7addc78281697bde98a701e9006d6",
  NEWS_API: "5de39280cf6b49c1aeef1c0b14c6754f",
};
export default APPCONFIG;
